// EmojiPicker.js
import React, { useState } from 'react';
import data from '@emoji-mart/data/sets/14/twitter.json';
import Picker from '@emoji-mart/react';
import { AccentButtonOutline } from './Buttons';

export const DEFAULT_EMOJI_FOR_CUSTOM_BUDGET_CATEGORY = '🛻';

interface EmojiPickerProps {
  value: string;
  onChange: (emoji: string) => void;
}

const EmojiPicker: React.FC<EmojiPickerProps> = ({ value, onChange }) => {
  const [isPickerVisible, setIsPickerVisible] = useState(false); // Toggle for showing/hiding the picker
  const handleEmojiSelect = (emoji: any) => {
    onChange(emoji.native); // Call the parent's onChange with the selected emoji
    setIsPickerVisible(false); // Close the picker after selection
  };

  return (
    <div className="flex flex-col items-start space-y-4">
      <div className="flex flex-row items-center space-x-2 align-middle">
        <h2 className="text-md block text-gray-700">Selected Emoji: </h2>
        <div className="text-3xl">
          {value || DEFAULT_EMOJI_FOR_CUSTOM_BUDGET_CATEGORY}
        </div>
        <AccentButtonOutline
          onClick={() => setIsPickerVisible((prev) => !prev)}
          addClass="rounded-full px-4 py-[1px]"
        >
          {isPickerVisible ? 'Close' : 'Pick Category Emoji'}
        </AccentButtonOutline>
      </div>

      {isPickerVisible && (
        <div className="mt-2">
          <Picker data={data} onEmojiSelect={handleEmojiSelect} />
        </div>
      )}
    </div>
  );
};

export default EmojiPicker;
